import React from 'react'
import { cn } from '~shared/utils/cn'

export const DocumentIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={cn(className)}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.388 0.916244C10.3429 0.913173 10.2974 0.911621 10.2518 0.911621H5.83073C3.91787 0.911621 2.36719 2.4623 2.36719 4.37516V13.1252C2.36719 15.038 3.91787 16.5887 5.83073 16.5887H11.6641C13.5769 16.5887 15.1276 15.038 15.1276 13.1252V6.38037H12.3932C11.2858 6.38037 10.388 5.48261 10.388 4.37516V0.916244ZM5.28385 8.75016C5.28385 8.44813 5.5287 8.20329 5.83073 8.20329H11.6641C11.9661 8.20329 12.2109 8.44813 12.2109 8.75016C12.2109 9.05219 11.9661 9.29704 11.6641 9.29704H5.83073C5.5287 9.29704 5.28385 9.05219 5.28385 8.75016ZM5.83073 11.8491C5.5287 11.8491 5.28385 12.094 5.28385 12.396C5.28385 12.698 5.5287 12.9429 5.83073 12.9429H8.7474C9.04943 12.9429 9.29427 12.698 9.29427 12.396C9.29427 12.094 9.04943 11.8491 8.7474 11.8491H5.83073Z'
        fill='#3A52EE'
      />
      <path
        d='M14.8152 5.28662C14.7692 5.21414 14.7183 5.14436 14.6628 5.07778L11.7923 1.63313C11.699 1.52121 11.5948 1.42085 11.4818 1.33309V4.37516C11.4818 4.87855 11.8898 5.28662 12.3932 5.28662H14.8152Z'
        fill='#3A52EE'
      />
    </svg>
  )
}
